"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var immutable_1 = require("immutable");
var helpers_1 = require("./helpers");
exports.getFacetType = function (value) {
    if (immutable_1.isImmutable(value)) {
        if (value instanceof immutable_1.Map)
            return types_1.Facets.range;
        if (value instanceof immutable_1.List)
            return types_1.Facets.category;
    }
    if (helpers_1.isArray(value))
        return types_1.Facets.category;
    if (helpers_1.isObject(value))
        return types_1.Facets.range;
    return types_1.Facets.text;
};
//# sourceMappingURL=filters.js.map